var App = App || {};

App.SkipAPayment = (function ($) {
    "use strict";

    function loanSearchSubmit(event) {
        event.preventDefault();
        var $form = $(this);

        if ($form.find(".zag-validation-invalid").length > 0)
            return false;

        $form.find("input[type='submit']").prop("disabled", "true")

        var last_name = $form.find("input[name='last_name']").val();
        var last_5 = $form.find("input[name='last_5']").val();

        $.ajax({
            type: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            url: "/api/sap_account/find",
            data: JSON.stringify({ "last_name": last_name, "last_5": last_5 }),
            dataType: "json",
            success: function (data) {
                if (data.statusCode === 200 && data.message === "SUCCESS") {
                    var template = $("#loan_defer_template").html();
                    var compiled_template = Handlebars.compile(template);
                    var template_html = compiled_template(data);
                    $("form#loan_defer").html(template_html);
                }
            },
            error: function (data) {
                $("form#loan_defer").html("<h2>Uh oh!</h2>An error occurred attempting to submit this request:  <br/><br/>" + data.responseJSON.responseException.exceptionMessage);
            },
            complete: function () {
                $form.find("input[type='submit']").prop("disabled", false);
            }
        });
    }

    function deferLoanSubmit(event) {
        event.preventDefault();
        var $form = $(this);

        if ($form.find(".zag-validation-invalid").length > 0)
            return false;

        var deferements = $.map($form.find("input[type='radio']:checked"), function (item) {
            if ($(item).val() !== "None")
                return { id: $(item).data("id"), value: $(item).val() };
        });

        var deferment_Account = $form.find("input[name='deferment_Account']").val();
        var deferment_Phone = $form.find("input[name='deferment_Phone']").val();

       $form.find("input[type='submit']").prop("disabled", "true")

        $.ajax({
            type: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            url: "/api/sap_account/deferment_request",
            data: JSON.stringify({
                "deferment_Account": deferment_Account,
                "deferment_Phone": deferment_Phone,
                "deferment_Acknowledgement": true,
                "deferments": deferements
            }),
            dataType: "json",
            success: function (data) {
                if (data.statusCode === 200 && data.message === "SUCCESS") {
                    $form.html("<div aria-label=\"Success! Your due dates will be advanced as requested, unless you hear from us otherwise.Please allow one business day for processing before contacting us with any questions or concerns.\"><h2>Success!</h2>Your due dates will be advanced as requested, unless you hear from us otherwise. Please allow one business day for processing before contacting us with any questions or concerns.</div>")
                } else {
                    $form.html("<h2>Uh oh!</h2>An error occurred attempting to submit this request: <br/><br/>" + data.message);
                }
            },
            error: function (data) {
                $form.html("<h2>Uh oh!</h2>An error occurred attempting to submit this request:  <br/><br/>" + data.responseJSON.responseException.exceptionMessage);
            },
            complete: function () {
                $form.find("input[type='submit']").prop("disabled", false);
            }
        });
    }

    function init() {
        $("form#loan_search").on("submit", loanSearchSubmit);
        $("form#loan_defer").on("submit", deferLoanSubmit);

        Handlebars.registerHelper('formatCurrency', function (value) {
            if (isNaN(value))
                return value;

            const formatter = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD'
            });
            return formatter.format(value);
        });
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.SkipAPayment.init();
});